// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"107":"1002805f","820":"3dd15085","951":"edfc31d5"}[chunkId] + ".css";
};